import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { VALUE_SEPARATOR } from './browsing';

export function useLocationQS<T extends string>(keys: T[]): { [key in T]: string[] } {
  const { search } = useLocation();
  // keys is often passed as an inline array, so track its contents instead of its
  // reference to keep the parsed QS stable between equivalent renders.
  const keysSignature = keys.join('|');

  return useMemo(
    () => parseUrlSearch(new URLSearchParams(search), keys),
    [search, keysSignature]
  );
}

export function parseUrlSearch<T extends string>(search: URLSearchParams, keys: T[]): { [key in T]: string[] } {
  const q = {} as { [key in T]: string[] };
  keys.forEach((k) => {
    q[k] = search.get(k)?.split(VALUE_SEPARATOR) || [];
  });
  return q;
}
